import { writable } from 'svelte/store';
import { localStorageService } from '$lib/services';

import type { Store, StoreState } from './types';

const initialValues: StoreState = {
    isUsersWithSubscription: false,
};

function createStore(): Store {
    const store = writable(initialValues);
    const { subscribe, update, set } = store;
    return {
        update,
        set,
        subscribe,
        setIsUsersWithSubscription: (value) => {
            localStorageService.setItem('onboardingUserWithSubscription', value);
            update(state => ({ ...state, isUsersWithSubscription: value }));
        },
    };
}

export const onboardingStore: Store = createStore();
